module.exports = __webpack_public_path__ + "img/mattress-none-boutique.35efb5f.svg";